import { configureStore } from '@reduxjs/toolkit';
import { type Middleware, combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';

import { type MobileCheckoutState, mobileCheckoutSlice } from './reducers/MobileCheckoutReducer';
import { type DrawersState, drawersReducer } from './reducers/drawers-reducer';
import { type NotificationsState, notificationsReducer } from './reducers/notifications-reducer';
import { type UserState, userSlice } from './slices/user';

export const reducer = {
  user: userSlice.reducer,
  mobileCheckout: mobileCheckoutSlice.reducer,
  notifications: notificationsReducer,
  drawers: drawersReducer,
};

export type State = {
  drawers: DrawersState;
  mobileCheckout: MobileCheckoutState;
  notifications: NotificationsState;
  user: UserState;
};

const persistConfig = { key: 'root', storage: storageSession, whitelist: ['user', 'settings'] };
const persistedReducer = persistReducer(persistConfig, combineReducers(reducer));

export const store = (loggers: Middleware[]) =>
  configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false, isImmutable: false }).concat(loggers),
  });

export type AppDispatch = ReturnType<typeof store>['dispatch'];
